import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("fa_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("fa_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("fa_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    localStorage.setItem("fa_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const updateProfile = async (payload) => {
    const res = await api.put("/auth/profile", payload);
    setUser(res.data);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("fa_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, admin: user, loading, login, register, updateProfile, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
